export const IND_EXP_TAB_DEEP_DIVE = 3;
export const IND_EXP_TAB_FLAGPOLE = 4;

export const isIndExpSubTabHidden = (tabIndex, isPublicSectorOhi) =>
    isPublicSectorOhi && (tabIndex === IND_EXP_TAB_DEEP_DIVE || tabIndex === IND_EXP_TAB_FLAGPOLE);

export const ADDITIONAL_PRACTICES_DEFAULT_LABEL = 'Additional Practices';

export const getIndExpSectionHeading = (isPublicSectorOhi, employeeExperienceLabel, additionalPracticesLabel) =>
    isPublicSectorOhi ? additionalPracticesLabel : employeeExperienceLabel;

export const mapPsOhiEmployeeExperienceText = (
    text,
    isPublicSectorOhi,
    additionalPracticesLabel = ADDITIONAL_PRACTICES_DEFAULT_LABEL
) => {
    if (!isPublicSectorOhi || text == null) return text;
    if (Array.isArray(text)) {
        return text.map(item => mapPsOhiEmployeeExperienceText(item, true, additionalPracticesLabel));
    }
    if (typeof text !== 'string') return text;
    return text
        .replace(/Employee Experience/gi, additionalPracticesLabel)
        .replace(/\bEX\b/g, additionalPracticesLabel)
        .replace(/\bEx\b/g, additionalPracticesLabel);
};

export const getBuComparisonLabel = (isPublicSectorOhi, buComparisonLabel, unitComparisonLabel) =>
    isPublicSectorOhi ? unitComparisonLabel : buComparisonLabel;

export const findIndExpHeatmapHeaderIndex = (elem, childIndex, headerSlug, header, headerTranslationMap = {}) => {
    let index = -1;

    if (headerSlug.length > childIndex) {
        const slugValue = headerSlug[childIndex];
        index = header.indexOf(slugValue);
        if (index === -1) {
            index = header.findIndex(h => h && slugValue && h.toLowerCase() === slugValue.toLowerCase());
        }
    }

    if (index === -1) {
        index = header.indexOf(elem);
        if (index === -1) {
            index = header.findIndex(h => h && elem && h.toLowerCase() === elem.toLowerCase());
        }
    }

    if (index === -1 && headerTranslationMap[elem]) {
        const translatedValue = headerTranslationMap[elem];
        index = header.indexOf(translatedValue);
        if (index === -1) {
            index = header.findIndex(h => h && translatedValue && h.toLowerCase() === translatedValue.toLowerCase());
        }
    }

    return index;
};

export const countIndExpHeatmapCategoryRows = ({
    children = [],
    headerSlug = [],
    header = [],
    arrItems = [],
    headerTranslationMap = {},
}) => {
    if (children.includes('N')) return 1;
    if (!header.length) return children.length;

    let matchedCount = 0;
    children.forEach((elem, childIndex) => {
        const index = findIndExpHeatmapHeaderIndex(elem, childIndex, headerSlug, header, headerTranslationMap);
        if (index !== -1 && arrItems[index] !== undefined) {
            matchedCount += 1;
        }
    });

    return matchedCount;
};
